<script lang="ts">
  export let content: string;
  export let matchid: string;
  export let showing: boolean = false;
  export let clickable: boolean;
  export let wordID: string;
  export let guideNumber: string;
</script>

<style>
  button {
    background-color: transparent;
    color: #eee;
    font-size: 1.5rem;
  }
  .square {
    border: 1px solid hsla(29, 100%, 61%, 1);
    margin: 5px;
    width: 80px;
    height: 80px;
    padding: 0 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img {
    width: 70px;
  }

  .card-cover {
    position: absolute;
    background-color: hsla(29, 100%, 51%, 1);
    top: 0;
    left: 0;
    font-size: 1.5rem;
    width: 100%;
    height: 100%;
    opacity: 1;
    outline: none;
    transition: opacity 0.3s ease-in-out;
    cursor: pointer;
  }

  button.card-cover:active {
    background-color: #ff9a39;
  }

  .card-show {
    opacity: 0;
  }

  .span-for-content {
    font-family: "Roboto", sans-serif;
    color: black;
    font-size: 1.1rem;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 320px) {
    .square {
      width: 75px;
      height: 75px;
      margin: 2%;
    }
  }
  @media only screen and (max-width: 360px) {
    .square {
      width: 75px;
      height: 75px;
      margin: 0;
    }
  }

  @media only screen and (min-width: 768px) {
    .square {
      width: 140px;
      height: 140px;
      margin: 0;
    }

    img {
      width: 130px;
    }

    .span-for-content {
      font-size: 1.5rem;
    }

    @keyframes shake {
      0% { transform: translate(1px, 1px) rotate(0deg); }
      20% { transform: translate(-1px, -2px) rotate(-1deg); }
      40% { transform: translate(-3px, 0px) rotate(1deg); }
      60% { transform: translate(3px, 2px) rotate(0deg); }
      80% { transform: translate(1px, -1px) rotate(1deg); }
      100% { transform: translate(-1px, 2px) rotate(-1deg); }
}

    .card-cover {
      font-size: 2.5rem;
    }

    .card-cover:hover {
      animation: shake 0.5s;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 992px) {
    .square {
      width: 160px;
      height: 160px;
      margin: 5px;
    }

    img {
      width: 150px;
    }

    .span-for-content {
      font-size: 2rem;
    }
  }
</style>

<button class="square">
  <button
    disabled={!clickable}
    class:card-show={showing}
    class="card-cover"
    data-name={matchid}
    id={wordID}
    on:click>{guideNumber}</button>
  {#if content.includes('http')}
    <img src={content} alt={matchid} />
  {:else}
    <div class="content {content}">
      <span class="span-for-content">{content}</span>
    </div>
  {/if}
</button>
